export default __webpack_public_path__ + "static/banner-mobile-tampons-3-d5a66d030296f42dcab027bbcd9a7fad.png";